/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import { StyleSheet } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import UITitle from '../../../components/UI/UITitle'
import LayoutRow from '../../../components/Layout/LayoutRow'
import LayoutCol from '../../../components/Layout/LayoutCol'
import { SPACE } from '../../../lib/spaces'
import { Auth, Amplify } from 'aws-amplify'
import config from '../../../config/aws'
import { BP_XS, MEDIA_MIN_SM } from '../../../lib/breakpoints'
import { COLOR_BLACK } from '../../../lib/colors'
import { WIDTH } from '../../../lib/helpers'
import { toast } from 'react-toastify'
import ReactCodeInput from 'react-code-input'

Amplify.configure({
  Auth: config.aws,
})

const styles = StyleSheet.create({
  container: {
    margin: 0,
    paddingBottom: SPACE * 10,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    color: COLOR_BLACK,
    [MEDIA_MIN_SM]: {
      fontSize: 48,
    },
  },
})

export const MailConfirmation = () => {
  const { t } = useTranslation('translation')
  const [valid, setValid] = useState(true)
  const valuesArray = JSON.parse(localStorage.getItem('userMaker'))
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email')
  const [Mail, setMail] = useState(valuesArray?.userMaker.email || email)
  let navigate = useNavigate()

  const [isLoadingVerification, setLoadingVerification] = useState(false)

  const submitMailVerification = async (e) => {
    if (e.length == 6) {
      try {
        setLoadingVerification(true)
        await toast.promise(Auth.confirmSignUp(Mail, e), {
          success: t('pages.confirm.success'),
          pending: t('pages.confirm.pending'),
          error: t('pages.confirm.error'),
        })
        setValid(true)
        navigate('../documents')
      } catch (error) {
        setValid(false)
        console.log(error)
      }
    }
  }

  return (
    <LayoutRow id="1">
      <LayoutCol col={WIDTH <= BP_XS ? 10 : 8} dynamicStyle={styles.container}>
        <UITitle
          label={t('pages.registerMaker.confirmation.title')}
          dynamicStyle={styles.title}
        />
        <h3>{t('pages.registerMaker.confirmation.desc')}</h3>
        <h4>{Mail}</h4>
        <ReactCodeInput
          isValid={valid}
          onChange={submitMailVerification}
          fields={6}
          disable={isLoadingVerification}
        />
      </LayoutCol>
    </LayoutRow>
  )
}
